import { Money } from '@dreryk/money-common-api';

import { MarginPosition, Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { advancePaymentStatusVisitor } from '../shared/advancePaymentStatusVisitor';
import { translationKeys } from '../translations';

import { getOverpaymentLabel, getUnderpaymentLabel } from './AdvancePaymentNotification.utils';

type AdvancePaymentNotificationProps = {
   paidAmount: Money;
   requiredAmount: Money;
};

export const AdvancePaymentNotification = (props: AdvancePaymentNotificationProps): JSX.Element => {
   return advancePaymentStatusVisitor(props, {
      visitPaid: () => (
         <Notification
            testId={'advancePaymentPaid'}
            type={NotificationType.SUCCESS}
            size={NotificationSize.SMALLER}
            margin={MarginPosition.NONE}
            label={translationKeys.advancePaymentPaid}
         />
      ),
      visitUnderpayment: () => (
         <Notification
            testId={'advancePaymentUnderpayment'}
            type={NotificationType.ERROR}
            size={NotificationSize.SMALLER}
            margin={MarginPosition.NONE}
            label={getUnderpaymentLabel(
               translationKeys.advancePaymentUnderpayment,
               props.paidAmount,
               props.requiredAmount
            )}
         />
      ),
      visitOverpayment: () => (
         <Notification
            testId={'advancePaymentOverpayment'}
            type={NotificationType.WARNING}
            size={NotificationSize.SMALLER}
            margin={MarginPosition.NONE}
            label={getOverpaymentLabel(
               translationKeys.advancePaymentOverpayment,
               props.paidAmount,
               props.requiredAmount
            )}
         />
      ),
   });
};
